import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import { Grid, TextField, Snackbar } from "@material-ui/core";
import Modal from "@mui/material/Modal";

import { Table, DatePicker, Button, Input, Select, Modal as AntdModal, } from 'antd';
import { CloseOutlined, DeleteOutlined, SearchOutlined } from '@ant-design/icons'

const { Option } = Select;
const { confirm } = AntdModal;
import { withRouter } from "react-router-dom";
import axios from "axios";
import FileCard from "../common/FileCard";
import FlowModal from "../common/FlowModal";
import DiagramModal from "../common/DiagramModal";
import LabelModal from "../common/LabelModal";
import ToTop from "../common/ToTop";
import {
  getAllFileList,
  getMarketFileList,
  getAllLableList,
  collectFile,
  getUserInfo,
  addLabelToFile,
  cancelCollectFile,
  delelteFileLabel,
  addCollectLabel,
  getZgfxLableList,
} from "../../actions/subscribe";
import InfiniteScroll from "react-infinite-scroll-component";

import {
  getLabelId,
  getCollectId,
  getUserFileLabelList,
} from "../../utils/common";
import MuiAlert from "@mui/material/Alert";

import showSvg from "../../assets/svg/show.svg";

import store from "../../store";
import Title from "antd/lib/skeleton/Title";
import { types } from "@babel/core";

const styles = () => {
  return {
    root: {
      width: "100%",
    },
    search: {
      width: "100%",
      height: "110px",
      padding: "18px 24px",
      flexFlow: "column",
      background: "#fff",
    },
    line: {
      marginTop: "12px",
      height: "25px",
      fontSize: "14px",
      color: "#000",
      display: "flex",
      alignItems: "center",
    },
    listMessage: {
      paddingLeft: "30px",
    },
    title: {
      marginRight: "10px",
      fontSize: "18px",
      fontWeight: "bold",
      color: "#5F6876",
    },
    total: {
      color: "#F04C35",
    },
    inputGroup: {},
    input: {
      width: "535px",
      height: "40px",
      borderRadius: "0",
      marginRight: "20px",
      "& fieldset": {
        borderWidth: "1px !important",
      },
      "& .MuiInputBase-root": {
        borderRadius: "0",
      },
    },
    btn: {
      width: "97px",
      height: "40px",
      background: "#0F25D1 !important",
      borderRadius: "0 !important",
    },
    select: {
      width: '100%'
    },
    grayBtn: {
      width: "97px",
      height: "40px",
      marginLeft: "18px !important",
      background: "#fff !important",
      borderRadius: "2px !important",
      border: "1px solid #d9d9d9 !important",
      color: "#0F25D1 !important",
      boxShadow: "none !important",
    },
    container: {
      paddingTop: '20px'
    },
    list: {
      paddingRight: "16px",
      width: "1px",
      "&.hide-time": {
        paddingLeft: "16px",
      },
    },
    label: {
      marginBottom: "16px",
    },
    labelContainer: {
      position: "sticky",
      top: "80px",
      minHeight: "400px",
      maxHeight: "calc(100vh - 140px)",
      padding: "20px 26px 20px 16px",
      background: "#fff",
      borderRadius: "10px",
      boxShadow: "0px 1px 10px 1px rgba(0, 0, 0, 0.05)",
      overflow: "auto",
    },
    labelTitle: {
      display: "flex",
      justifyContent: "space-between",
      marginBottom: "10px",
    },
    titleLeft: {
      display: "flex",
      alignItems: "center",
      color: "#42BD57",
      fontSize: "18px",
      fontWeight: "bold",
      "& img": {
        width: "21px",
        height: "21px",
        marginRight: "10px",
      },
      "& button": {
        marginLeft: "20px",
        width: "82px",
        height: "32px",
        padding: "0 10px",
        borderRadius: "0",
        borderColor: "#D9D9D9",
        color: "#000",
        fontSize: "14px",
      },
    },
    showBtn: {
      width: "82px",
      height: "32px",
      padding: "0 !important",
      border: "1px solid #d9d9d9 !important",
      borderRadius: "2px",
      backgroundColor: "#fff !important",
      color: "rgba(0, 0, 0, .65) !important",
      fontSize: "14px",
      boxShadow: "none !important",
      "&.first": {
        marginRight: "10px",
      },
    },
    subTitle: {
      display: "flex",
      alignItems: "center",
      height: "22px",
      margin: "12px 0",
      lineHeight: "22px",
      fontSize: "16px",
      color: "#4A4A4A",
      fontWeight: "bold",
      "& img": {
        marginRight: "3px",
        "&.hide": {
          transform: "rotate(-90deg)",
        },
      },
    },
    tag: {
      height: "22px",
      margin: "0 10px 16px 0",
      lineHeight: "22px",
      fontSize: "14px",
      color: "#000",
      fontWeight: "400",
      padding: "0 12px",
      display: "inline-block",
      border: "1px solid #E9E9E9",
      borderRadius: "4px",
      cursor: "pointer",
      "&.active": {
        color: "#0F25D1",
        borderColor: "#0F25D1",
      },
    },
    categoryLine: {
      height: "46px",
      padding: "0 7px",
      borderBottom: "1px dashed #d8d8d8",
      overflow: "hidden",
      "&.show": {
        height: "auto",
      },
    },
    textBtn: {
      color: '#444',
      padding: '0 5px',
      "&:hover": {
        color: '#1890ff !important'
      }
    },
    linkText: {
      color: '#333',
      '&:hover': {
        color: '#333',
        textDecoration: 'underline'
      }
    }
  };
};

class SearchFilePage extends Component {
  state = {
    tabList: [
      {
        title: '法律法规',
        type: ''
      },
      {
        title: '法规',
        type: '法规'
      },
      {
        title: '标准',
        type: '标准'
      },
      {
        title: '指导原则',
        type: '指导原则'
      },
    ],
    tabIndex: 0,
    searchType: "",
    keyword: "",
    baseKeyword: "",
    error: "",
    search_filters: {},
    page: 1,
    is_all: 0,
    count: 0,
    title: "",
    userId: "", //用户id
    username: "", //用户名
    dataId: "", //弹框数据id,点击右侧管理收藏按钮时，传空
    openMessage: "",
    errorMessage: "",
    // push: true,
    openModal: false,
    openDiagramModal: false,
    showTimeLine: true, // 是否展示时间线
    highText: false,
    modalTitle: "",
    fileList: [],
    labelList: [],
    labelArr: [],
    tagList: [],
    tagArr: [],
    collectFileId: [],
    collectLabelId: [],
    baseFileId: "", // 图谱根节点文件id
    showAll: false,
    hideSearchBtn: false, //隐藏智能搜索按钮
    flowModal: false, // 分类流程
    filterName: "", // 分类流程类型
    medical_file: "",
    company: "",
    fileType: "",
    updateTime: '',
    searchHistoryList: [],
    form: {
      type: "",
      keyword: "",
    },
    defaultForm: { // 默认值
      type: "",
      keyword: "",
    },
    labelObj: { // 筛选项key - label对应关系
      type: '搜索类型',
      keyword: '关键词',
    },
    labelListObj: { 
      type: 'searchTypeList'
    },
    selectKeys: ['type'],
    searchTypeList: [
      {
        ID: '',
        Name: '精确搜索'
      },
      {
        ID: 'es',
        Name: '智能搜索'
      },
      {
        ID: 'all',
        Name: '全文搜索'
      },
    ],
    loading: false,
    data: [],
    columns: [
      {
        title: '操作',
        dataIndex: 'TotalSerialNumber',
        key: 'TotalSerialNumber',
        width: 180,
        align: 'center',
        render: (text, row) => {
          return (
            <>
              {/* <Button type="text" className={this.props.classes.textBtn}>翻译</Button> */}
              <Button type="text" className={this.props.classes.textBtn} onClick={() => this.doCollect(row)}>
                {
                  this.state.collectFileId.includes(
                    row.base_file.file_id
                  ) ? '取消收藏' : '收藏'
                }
              </Button>
              <Button className={this.props.classes.textBtn} type="text" onClick={() => this.downloadFile(row.base_file.dfs_url, row.base_file.file_name)}>下载</Button>
            </>
          )
        }
      },
      {
        title: '文件类型',
        dataIndex: 'file_category',
        key: 'file_category',
        width: 130,
        render: (text, row) => row.base_file.file_category
      },
      {
        title: '文件名称',
        dataIndex: 'TotalSerialNumber',
        key: 'TotalSerialNumber',
        width: 370,
        render: (text, row) => (<a className={this.props.classes.linkText} onClick={() => this.previewFile(row.base_file.dfs_url)} >{row.base_file.file_name}</a>)
      },
      {
        title: '发布机构',
        dataIndex: 'medical_file_publish_orgnization',
        key: 'medical_file_publish_orgnization',
        width: 140,
      },
      {
        title: '发布时间',
        dataIndex: 'TotalSerialNumber',
        key: 'TotalSerialNumber',
        width: 140,
        render: (text, row) => row.medical_file_publish_date.substring(0, 10)
      },
      {
        title: '立法阶段',
        dataIndex: 'medical_file_law_status',
        key: 'medical_file_law_status',
        width: 120,
      },
      {
        title: '性质类型',
        dataIndex: 'TotalSerialNumber',
        key: 'TotalSerialNumber',
        width: 120,
      },
      {
        title: '网页链接',
        dataIndex: 'medical_file_website_link',
        key: 'medical_file_website_link',
        width: 240,
        render: (text, row) => (<a target="_blank" href={row.medical_file_website_link}>{row.medical_file_website_link}</a>)
      },
    ],
    paginationObj: {
      showSizeChanger: true,
      total: 0,
      showTotal: (total, range) => {
        return '共【' + this.state.paginationObj.total + '】条'
      },
      onChange: (page, pageSize) => {
        this.pageChange(page, pageSize)
      },
    },
    page: {
      page: 1,
      pageSize: 10
    },
    scrollObj: {
      x: 1560
    }
  };

  componentDidMount() {
    
    this.getTableHeight()

    let date = new Date()
    let year = date.getFullYear()
    let month = date.getMonth() + 1
    let day = date.getDate()
    let today = `${year}-${month < 10 ? `0${month}` : month}-${day < 10 ? `0${day}` : day}`
    this.setState({
      updateTime: today
    })

    let pathname = this.props.location.pathname;
    let keyword = "";
    let title = "";
    let company = "";
    let fileType = "";
    switch (pathname) {
      case "/yrdCenter":
        keyword = "长三角";
        title = "长三角分中心";
        this.setState({ hideSearchBtn: true });
        break;
      case "/gbaCenter":
        keyword = "大湾区";
        title = "大湾区分中心";
        this.setState({ hideSearchBtn: true });
        break;
      case "/medical":
        keyword = "博鳌";
        title = "博鳌医疗先行区";
        break;
      case "/market":
        company = "zgfx";
        fileType = "政府事务和市场准入";
        title = "政府事务和市场准入";
        break;
      default:
        break;
    }
    this.setState(
      {
        username: store.getState().auth.username,
        baseKeyword: keyword,
        company: company,
        fileType: fileType,
        title: title
      },
      () => {
        this.queryUserInfo();
        this.loadMore();
      }
    );
    if (company == "zgfx") this.queryZgfxLable(fileType);
    else this.queryLable();
  }

  resetForm = () => {
    this.setState({
      form: {
        type: "",
        keyword: "",
      }
    })
  }

  getTableHeight = () => {
    // 计算表格高度
    let height = window.innerHeight
    let lineHeight = document.getElementById('searchBar').offsetHeight
    this.setState({
      scrollObj: {
        x: 1560,
        y: height - lineHeight - 211
      }
    })
  }

  clearHistory = () => {
    this.resetForm()
    this.setState({
      searchHistoryList: []
    }, () => {
      this.loadMore()
      this.getTableHeight()
    })
  }

  removeSearchItem = (data, i) => {
    let form = {
      ...this.state.form
    }
    let list = [].concat(this.state.searchHistoryList)
    form[data.key] = this.state.defaultForm[data.key]
    list.splice(i, 1)
    this.setState({
      form: form,
      searchHistoryList: list
    }, () => {
      this.loadMore()
      this.getTableHeight()
    })
  }

  searchForm = () => {
    this.loadMore()
    // 添加历史搜索记录
    let form = {
      ...this.state.form
    }
    let list = [].concat(this.state.searchHistoryList)
    for (let key in form) {
      let index = list.findIndex(v => {
        return v.key == key
      })
      if (form[key] && form[key].length > 0) {
        let showValue = form[key]
        let label = ''
        if (this.state.selectKeys.indexOf(key) > -1) {
          label = this.state[this.state.labelListObj[key]].find(v => {
            return v.ID == showValue
          }).Name
        }
        if (index === -1) {
          let param = {
            label: this.state.labelObj[key],
            value: label || showValue,
            key: key
          } 
          list.push(param)
        } else {
          let itemIndex = list.findIndex(v => {
            return v.key == key
          })
          list[itemIndex].value = label || showValue
        }
      } else {
        if (index > -1) {
          list.splice(index, 1)
        }
      }
    }
    this.setState({
      searchHistoryList: list
    }, () => this.getTableHeight())
  }

  handleChange = (pagination, filters, sorter) => {
    this.setState(
      {
        loading: true,
      },
      () => {
        this.loadMore();
      }
    );
  };

  pageChange = (page, pageSize) => {
    if (page == this.state.page.page && pageSize == this.state.page.pageSize) {
      return
    }
    this.setState({
      page: {
        page: page,
        pageSize: pageSize
      },
      loading: true
    }, () => this.loadMore())
  }

  downloadFile = (url, fileName) => {
    axios({
      method: "get",
      url: url,
      responseType: "blob",
    }).then((resp) => {
      if (resp.status === 200) {
        if (window.navigator.msSaveOrOpenBlob) {
          let blob = resp.data;
          navigator.msSaveBlob(blob, fileName);
        } else {
          let blob = new Blob([resp.data], { type: "text" });
          let a = document.createElement("a");
          a.download = fileName;
          let URL = window.URL || window.webkitURL;
          a.href = URL.createObjectURL(blob);
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        }
      }
    });
  };

  //查询用户信息;
  queryUserInfo = () => {
    getUserInfo({ username: this.state.username }).then((res) => {
      if (res.results && res.results.length > 0) {
        let userData = res.results[0];
        if (userData) {
          this.setState({
            userId: userData.id,
            collectFileId: userData.favorite_basefiles.map((v) => {
              return v.basefile_id;
            }),
            collectLabelId: userData.favorite_lables.map((v) => {
              return v.lable_id;
            }),
          });
        }
      }
    });
  };

  onChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };
  previewFile = (url) => {
    localStorage.setItem('previewUrl', url);
    const w = window.open("ablut:blank");
    w.location.href = "/preview";
  };

  queryLable = () => {
    const param = {
      lable_category_type: "高级筛选",
      is_shown: true,
    };
    getAllLableList(param).then((res) => {
      this.setState({
        labelList: res.results,
      });
    });
  };
  queryZgfxLable = (fileType) => {
    const param = {
      fileType: fileType,
    };
    getZgfxLableList(param).then((res) => {
      this.setState({
        labelList: res.results,
      });
    });
  };

  onChangeForm = (value, key) => {
    let form = {
      ...this.state.form
    }
    form[key] = value
    this.setState({
      form: form
    })
  }

  loadMore = async () => {
    this.setState({
      loading: true
    })
    let keyword = [];
    if (this.state.form.keywordkeyword) {
      keyword.push(this.state.form.keyword);
    }
    if (this.state.baseKeyword) {
      keyword.push(this.state.baseKeyword);
    }
    let is_all = 0
    let searchType = ""
    if (this.state.form.type == "all") {
      searchType = "全文检索"
    }
    const param = {
      search_filters: this.state.search_filters,
      keyword: keyword.join(),
      company: this.state.company,
      fileType: this.state.fileType,
      is_all: is_all,
      searchType: searchType,
      ...this.state.page
    };
    let res = this.state.fileType == '政府事务和市场准入' ? await getMarketFileList(param) : await getAllFileList(param)
    if (res && res.results) {
      let data = res.results
      let newPaginationObj = this.state.paginationObj
      newPaginationObj.total = res.count
      this.setState({
        data: data,
        paginationObj: newPaginationObj,
        loading: false
      });
    } else {
      this.setState({
        loading: false
      })
    }
  };

  searchFile = () => {
    this.setState(
      {
        page: 1,
        is_all: 0,
        searchType: "",
        showTimeLine: true,
        highText: false,
      },
      () => this.loadMore(true)
    );
  };
  searchAllFile = () => {
    this.setState(
      {
        page: 1,
        is_all: 1,
        searchType: "",
        showTimeLine: true,
        highText: false,
      },
      () => this.loadMore(true)
    );
  };

  elasticSearch = () => {
    if (!this.state.keyword) {
      return;
    }
    this.setState(
      {
        page: 1,
        searchType: "es",
        showTimeLine: false,
        highText: true,
      },
      () => this.loadMore(true)
    );
  };


  changeLabel = (label, category) => {
    let categoryName = category.lable_category_name;
    let labelName = label.lable_content;
    let labelId = label.lable_id;
    let search_filters = JSON.parse(JSON.stringify(this.state.search_filters));
    if (search_filters.hasOwnProperty(categoryName)) {
      let labelArr = search_filters[categoryName];
      let labelIndex = labelArr.findIndex((v) => {
        return v == labelName;
      });
      if (labelIndex > -1) {
        if (labelArr.length == 1) {
          delete search_filters[categoryName];
        } else {
          labelArr.splice(labelIndex, 1);
        }
      } else {
        labelArr.push(labelName);
      }
    } else {
      search_filters[categoryName] = [labelName];
    }

    let newArr = this.state.labelArr.concat([]);
    if (newArr.includes(labelId)) {
      newArr.splice(newArr.indexOf(labelId), 1);
    } else {
      newArr.push(labelId);
    }
    this.setState(
      {
        search_filters: search_filters,
        labelArr: newArr,
        page: 1,
      },
      () => this.loadMore(true)
    );
  };

  changeShow = (i) => {
    let show = this.state.labelList[i].showDetail;
    let newLabelList = [].concat(this.state.labelList);
    if (show) {
      newLabelList[i].showDetail = false;
    } else {
      newLabelList[i].showDetail = true;
    }
    let showAll = this.state.showAll;
    let size = newLabelList.filter((v) => {
      return v.showDetail;
    }).length;
    if (size == 0) {
      showAll = false;
    }
    if (size == newLabelList.length) {
      showAll = true;
    }
    this.setState({
      labelList: newLabelList,
      showAll: showAll,
    });
  };

  showAllDetail = () => {
    let newLabelList = [].concat(this.state.labelList);
    newLabelList.forEach((v) => {
      v.showDetail = !this.state.showAll;
    });
    this.setState({
      labelList: newLabelList,
      showAll: !this.state.showAll,
    });
  };

  clearAllFilter = () => {
    this.setState(
      {
        search_filters: {},
        labelArr: [],
        page: 1,
      },
      () => this.loadMore(true)
    );
  };

  handleClose = () => {
    this.setState({
      openModal: false,
    });
    this.queryUserInfo();
  };

  //收藏文件
  handAdd = (tag) => {
    //检查是否已存在
    let index = this.state.tagArr.findIndex((v) => {
      return v.lable_content == tag;
    });
    if (index > -1) {
      this.setState({
        openMessage: true,
        errorMessage: "该标签已存在",
      });
      setTimeout(() => {
        this.closeMessage();
      }, 3000);
      return;
    }
    //获取标签id
    getLabelId(tag, this.state.userId).then((labelId) => {
      //打标签
      addLabelToFile({
        base_file: this.state.dataId,
        lable: labelId,
        lable_update_user: this.state.userId,
      }).then((resp) => {
        if (resp.id) {
          this.setState({
            tagArr: this.state.tagArr.concat([
              {
                lable_content: tag,
                lable_id: labelId,
              },
            ]),
          });
        }
      });

      //收藏标签
      if (this.state.collectLabelId.includes(labelId) == false) {
        addCollectLabel({
          lable: labelId,
          user: this.state.userId,
        });
      }
    });
  };

  handRemove = (id) => {
    // getFileLabelId(this.state.dataId, id, this.state.userId).then(fileLabelId => {
    delelteFileLabel(id);
    // })
    let tagArr = [].concat(this.state.tagArr);
    let index = tagArr.findIndex((v) => {
      return v.lable_id === id;
    });
    tagArr.splice(index, 1);
    this.setState({
      tagArr: [].concat(tagArr),
    });
  };

  //收藏、取消搜藏
  doCollect = (row) => {
    let isCollect = this.state.collectFileId.includes(
      row.base_file.file_id
    )
    if (isCollect) {
      confirm({
        title: '确认',
        content: '确认取消收藏？',
        onOk: () => {
          this.handCancelCollect(row.base_file.file_id)
        }
      })
    } else {
      this.handCollect(row.base_file.file_id)
    }
  }

  //收藏文件
  handCollect = (id) => {
    this.setState({
      openModal: true,
      modalTitle: "文件收藏",
      dataId: id,
      tagArr: [],
    });
    //收藏文件
    collectFile({
      base_file: id,
      user: this.state.userId,
    }).then(() => {
      this.queryUserInfo();
    })
  };
  //取消收藏
  handCancelCollect = (id) => {
    getCollectId(id, this.state.userId).then((collectId) => {
      cancelCollectFile(collectId).then((res) => {
        if (res && res.message) {
          message.warning(res.message)
        } else {
          message.success('取消成功')
          this.queryUserInfo();
        }
      });
    });
  };
  //管理标签
  handSetting = (id) => {
    getUserFileLabelList(id, this.state.userId).then((list) => {
      this.setState({
        openModal: true,
        dataId: id,
        modalTitle: "管理标签",
        tagArr: list,
      });
    });
  };
  // 分类流程
  handFlow = (data) => {
    this.setState({
      flowModal: true,
      medical_file: data,
      filterName: data.base_file.file_category,
    });
  };
  closeFlow = () => {
    this.setState({
      flowModal: false,
    });
  };
  //图谱
  handleDiagram = (id) => {
    this.setState({
      openDiagramModal: true,
      baseFileId: id,
    });
  };
  //关闭弹框
  handleClose = () => {
    this.setState({
      openModal: false,
      openDiagramModal: false,
    });
    this.queryUserInfo();
  };

  //关闭消息弹框
  closeMessage = () => {
    this.setState({
      openMessage: false,
    });
  };

  //回车事件
  onKeyDownchange = (e) => {
    if (e.keyCode == 13) {
      this.searchFile();
    }
  };

  changeTab = (data) => {

  }

  render() {
    const classes = this.props.classes;

    return (
      <div className="common-page">
        <div className="common-left-search">
          <div className="left-search-title">
            <span className="search-title">关键词搜索</span>
            
          </div>
          <div className="search-form">
            <div className="form-item">
              <div className="form-label">搜索类型</div>
              <Select
                allowClear
                className={classes.select}
                placeholder="请选择"
                value={this.state.form.type}
                onChange={(e) => this.onChangeForm(e, 'type')} 
              >
                {
                  this.state.searchTypeList.map((v, i) => {
                    return (
                      <Option value={v.ID} key={i}>{v.Name}</Option>
                    )
                  })
                }
              </Select>
            </div>
            <div className="form-item">
              <div className="form-label">关键词</div>
              <Input  value={this.state.form.keyword}
                allowClear
                onChange={(e) => this.onChangeForm(e.target.value, 'keyword')} 
                placeholder="请输入关键词"/>
            </div>
          </div>

          <div className="search-bottom-btns">
            <Button className="default-btn" onClick={this.resetForm}>重置</Button>
            <Button className="primary-btn" onClick={this.searchForm}>搜索</Button>
          </div>
        </div>

        <div className="common-main">
          <div className="common-main-search" id="searchBar">
            <div className="main-title">
              <div className="title-top">
                <div>
                  <span className="page-title">{this.state.title}</span>
                  <span className="page-count">{this.state.paginationObj.total}条</span>
                </div>
                <span >数据更新至：{this.state.updateTime}</span>
              </div>
            </div>
            {
              this.state.searchHistoryList.length > 0 &&
              <div className="search-history">
                {
                  this.state.searchHistoryList.map((item, i) => (
                    <div className="history-item" key={i}>
                      <span>{item.label}：</span>
                      <span className="history-value">{item.value}</span>
                      <CloseOutlined className="clear-icon" onClick={() => this.removeSearchItem(item, i)}/>
                    </div>
                  ))
                }
                <div className="hitstory-btn" onClick={this.clearHistory}>
                  <DeleteOutlined className="btn-icon"/>
                  清空
                </div>
              </div>
            }
          </div>
          <div className="common-main-container">
           
            <Grid container className={classes.container} id="tableContainer">
              <Table 
                className={classes.tableContainer}
                columns={this.state.columns} 
                loading={this.state.loading} 
                dataSource={this.state.data} 
                onChange={this.handleChange} 
                pagination={this.state.paginationObj}
                scroll={this.state.scrollObj}
                bordered
                />
              
            </Grid>
          </div>
        </div>

        {/* <ToTop /> */}

        <Modal
            open={this.state.openModal}
            onClose={this.handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <div>
              <LabelModal
                width={520}
                title={this.state.modalTitle}
                close={this.handleClose}
                tagArr={this.state.tagArr}
                handAdd={this.handAdd}
                handRemove={this.handRemove}
                dataId={this.state.dataId}
                // recommendList={this.state.recommendList}
              />
            </div>
          </Modal>

          <Modal
            open={this.state.flowModal}
            onClose={this.closeFlow}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <div>
              <FlowModal
                medical_file={this.state.medical_file}
                filterName={this.state.filterName}
                close={this.closeFlow}
              />
            </div>
          </Modal>
          <Modal
            open={this.state.openDiagramModal}
            onClose={this.handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <div>
              <DiagramModal fileId={this.state.baseFileId} />
            </div>
          </Modal>

          <Snackbar
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
            open={this.state.openMessage}
            onClose={this.closeMessage}
          >
            <MuiAlert elevation={6} variant="filled" severity="warning">
              {this.state.errorMessage}
            </MuiAlert>
          </Snackbar>
      </div>
    );
  }
}

export default withStyles(styles)(withRouter(SearchFilePage));
